import React from 'react';
import { Link } from 'react-router-dom';

const Topbar = () => {
  return (
    <div className="container-fluid bg-primary px-5 d-none d-lg-block">
      <div className="row gx-0 align-items-center">
        <div className="col-lg-5 text-center text-lg-start mb-lg-0">
          <div className="d-flex">
            <Link to={`mailto:info@example.com`} className="text-muted me-4">
              <i className="fas fa-envelope text-secondary me-2"></i>info@example.com
            </Link>
            <Link to={`tel:+01234567890`} className="text-muted me-0">
              <i className="fas fa-phone-alt text-secondary me-2"></i>+01234567890
            </Link>
          </div>
        </div>
        <div className="col-lg-3 row-cols-1 text-center mb-2 mb-lg-0">
            <div className="d-inline-flex align-items-center" style={{ height: '45px' }}>
              <button type="button" className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" aria-label="twitter">
                <i className="fab fa-twitter fw-normal text-secondary"></i>
              </button>
              <button type="button" className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" aria-label="facebook">
                <i className="fab fa-facebook-f fw-normal text-secondary"></i>
              </button>
              <button type="button" className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" aria-label="linkedin">
                <i className="fab fa-linkedin-in fw-normal text-secondary"></i>
              </button>
              <button type="button" className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" aria-label="instagram">
                <i className="fab fa-instagram fw-normal text-secondary"></i>
              </button>
            </div>
        </div>
        <div className="col-lg-4 text-center text-lg-end">
          <div className="d-inline-flex align-items-center" style={{ height: '45px' }}>
            <button type="button" className="text-muted me-2 btn btn-link p-0">Help</button><small> / </small>
            <button type="button" className="text-muted mx-2 btn btn-link p-0">Support</button><small> / </small>
            <Link to="/contact" className="text-muted ms-2">Contact</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar; 